import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';

interface AmbitoState {
  selectedAmbitoId: number | null;
  setSelectedAmbito: (id: number | null) => void;
  reset: () => void;
}

/**
 * Selected-ambito store. Persisted to sessionStorage to match auth.store scope:
 * the ambito selection should NOT survive across browser-tabs/users (prevents
 * a previous session's ambito leaking into a new login on the same machine).
 */
export const useAmbitoStore = create<AmbitoState>()(
  persist(
    (set) => ({
      selectedAmbitoId: null,
      setSelectedAmbito: (id) => set({ selectedAmbitoId: id }),
      reset: () => set({ selectedAmbitoId: null }),
    }),
    {
      name: 'sime-ambito',
      storage: createJSONStorage(() => sessionStorage),
    },
  ),
);
